import { useMutation, useQueryClient } from '@tanstack/react-query'

import { profileApi, type StudentDocument } from '@/features/student/api/profile.api'
import { PROFILE_QUERY_KEY } from '@/features/student/hooks/useProfile'

export function useUploadDocument() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      file,
      documentType,
    }: {
      file: File
      documentType: StudentDocument['documentType']
    }) => profileApi.documents.upload(file, documentType),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: PROFILE_QUERY_KEY }),
  })
}

export function useDeleteDocument() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => profileApi.documents.remove(id),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: PROFILE_QUERY_KEY }),
  })
}

export function useDownloadDocument() {
  return useMutation({ mutationFn: (id: number) => profileApi.documents.download(id) })
}

export function useDownloadResume() {
  return useMutation({ mutationFn: profileApi.downloadResume })
}

export function useDownloadPhoto() {
  return useMutation({ mutationFn: profileApi.downloadPhoto })
}
